import { ChangeDetectorRef, Component, HostBinding } from '@angular/core';

@Component({
  selector: 'app-standard-page',
  templateUrl: 'standard-page.component.html',
  styleUrls: ['standard-page.component.scss'],
  standalone: false,
})
export class StandardPageComponent {
  @HostBinding('class') get cssClass() {
    return 'body-container-content pt-3 ps-3 pe-3' + this.customCssClass;
  }

  private customCssClass = '';

  constructor(private cd: ChangeDetectorRef) {}

  addCssClass(cssClass: string) {
    if (!new RegExp(` ${cssClass}( |$)`).test(this.customCssClass)) {
      setTimeout(() => {
        this.customCssClass += ' ' + cssClass;
        this.cd.markForCheck();
      });
    }
  }
}
